/*
  cc-header-search.js: CaptCan search engine and dropdown (replaced Fast Simon's autocomplete).

  window.ccSearch.attach(form, input, opts) turns any search box into a CaptCan search:
    - a "What" picker in the box: All, Back Issues or Pre-Sales
    - a dropdown with "Search by" (Everything, Titles, Characters, Creators, Publishers) and
      "Match in" (Titles & descriptions, Titles only) plus "Exact phrase"
    - before typing: recent searches, popular searches, quick links and featured products
    - while typing: suggestions, titles (series from the captcan app, with stock counts and a
      "did you mean" retry), characters, creators and publishers on the left; covers with
      Pre-Sale / FOC / Sold out badges on the right, the total, and a link to all results
  The header box ([data-live-search-form]) is attached automatically. The homepage search strip
  (sections/cc-search-strip.liquid) attaches its own box with its own scope buttons.

  Enter with nothing highlighted:
    Everything -> /search?q=..&kind=..&in=title&exact=1 (CC Search Grid page)
    Titles     -> the advanced series search (/pages/advanced-search?q=..)
    Characters, Creators, Publishers -> the best matching collection

  Also used by the results page (cc-search-hero, cc-search-grid) and advanced-comic-search:
  ccSearch.buildQuery, ccSearch.matches, ccSearch.didYouMean, ccSearch.focBadge.
  Config comes from window.ccHeaderSearch (snippets/cc-header-search.liquid).
  Empire's own live search must stay off (header setting "Enable live search").
*/
(function () {
  'use strict';

  var CFG = window.ccHeaderSearch || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 180;
  var APP_TIMEOUT_MS = 2500;
  var RECENT_KEY = 'cc:recent-searches';
  var PREFS_KEY = 'cc:search-prefs';
  var RECENT_MAX = 6;

  var KINDS = [
    { id: '', label: 'All', query: '' },
    { id: 'back-issues', label: 'Back Issues', query: 'product_type:"Back Issue"' },
    { id: 'presales', label: 'Pre-Sales', query: 'tag:presale' }
  ];
  var SCOPES = [
    { id: 'all', label: 'Everything' },
    { id: 'title', label: 'Titles' },
    { id: 'character', label: 'Characters' },
    { id: 'creator', label: 'Creators' },
    { id: 'publisher', label: 'Publishers' }
  ];
  // Sidebar groups per scope: [group, heading, max]
  var PLAN = {
    all: [['issue', 'Issues', 3], ['query', 'Suggestions', 4], ['series', 'Titles', 5], ['character', 'Characters', 3], ['creator', 'Creators', 3], ['publisher', 'Publishers', 2]],
    title: [['issue', 'Issues', 3], ['series', 'Titles', 10], ['query', 'Suggestions', 3]],
    character: [['character', 'Characters', 12]],
    creator: [['creator', 'Creators', 12]],
    publisher: [['publisher', 'Publishers', 12]]
  };
  // Collection searches per scope. Prefixing the collection title words ranks the right kind first.
  var COLLECTION_QUERIES = {
    all: [''],
    title: [''],
    character: ['character '],
    creator: ['writer ', 'cover artist '],
    publisher: ['publisher ']
  };

  // Common collector shorthand, expanded before searching.
  var ALIASES = {
    asm: 'amazing spider-man',
    tasm: 'amazing spider-man',
    ff: 'fantastic four',
    tmnt: 'teenage mutant ninja turtles',
    gotg: 'guardians of the galaxy',
    jla: 'justice league of america',
    jsa: 'justice society of america',
    xmen: 'x-men',
    uxm: 'uncanny x-men',
    spiderman: 'spider-man',
    'spider man': 'spider-man',
    'x men': 'x-men',
    ww: 'wonder woman',
    gl: 'green lantern',
    bprd: 'b.p.r.d.',
    tos: 'tales of suspense',
    tta: 'tales to astonish'
  };
  Object.keys(CFG.aliases || {}).forEach(function (k) { ALIASES[k.toLowerCase()] = CFG.aliases[k]; });
  var ALIAS_KEYS = Object.keys(ALIASES).sort(function (a, b) { return b.length - a.length; });

  var skipImages = String(CFG.skipImages || '').toLowerCase().split(',')
    .map(function (v) { return v.trim(); }).filter(Boolean);

  // ---------- query handling ----------

  // "asm #300" -> { text: "amazing spider-man 300", series: "amazing spider-man", number: "300" }
  // "asm 300 1988" and "asm 300 (1988)" also give year: "1988", which narrows results but never empties them.
  function parseQuery(raw) {
    var q = String(raw || '').toLowerCase().replace(/\s+/g, ' ').trim();
    var number = null, year = null, grade = null;
    // A trailing grade after an issue number ("asm 300 9.8", "300 cgc 9.6", "300 nm", "300 vf/nm")
    // describes the copy, not the issue: it is set aside so the issue is still found.
    var GRADE_END = /\s+((?:(?:cgc|cbcs|pgx)\s*)?(?:10(?:\.0)?|\d\.\d)|cgc|cbcs|pgx|graded|ungraded|raw|slabbed|slab|near mint|very fine|nm\/m|nm[+-]?|vf\/nm|vf[+-]?|fn\/vf|fn[+-]?|vg\/fn|vg[+-]?|gd\/vg|gd[+-]?|fr|pr)$/;
    var ISSUE_END = /(?:#\s*|\s|^)\d{1,4}(?:\.\d)?[a-z]?(?:\s+\(?(?:19[3-9]\d|20\d\d)\)?)?$/;
    for (var gm; (gm = q.match(GRADE_END)) && ISSUE_END.test(q.slice(0, q.length - gm[0].length));) {
      grade = grade ? gm[1] + ' ' + grade : gm[1];
      q = q.slice(0, q.length - gm[0].length).trim();
    }
    // A trailing year counts only in brackets or straight after an issue number, so "spider-man 2099" stays a title.
    var y = q.match(/\s\((19[3-9]\d|20\d\d)\)$/) || q.match(/(?:#\s*|\s)\d{1,4}(?:\.\d)?[a-z]?\s+(19[3-9]\d|20\d\d)$/);
    if (y) {
      year = y[1];
      q = q.slice(0, q.length - (y[0].indexOf('(') > -1 ? y[0].length : y[1].length + 1)).trim();
    }
    // Trailing issue number: "#1000", "no. 12", "issue 300", or a bare 1-3 digit number.
    // Bare 4-digit numbers are left alone so "spider-man 2099" stays a title.
    var m = q.match(/(?:^|\s)(?:#\s*|no\.?\s*|issue\s+)(\d{1,4}(?:\.\d)?)$/) ||
      q.match(/(?:^|\s)(\d{1,3}(?:\.\d)?)$/);
    if (m && q.replace(m[0], '').trim()) {
      number = m[1];
      q = q.slice(0, q.length - m[0].length).trim();
    }
    q = q.replace(/#/g, ' ').replace(/\s+/g, ' ').trim();
    // A leading "the" is optional: searches run with and without it (see withAndWithoutThe).
    var hadThe = /^the\s+\S/.test(q);
    if (hadThe) q = q.slice(4);
    ALIAS_KEYS.forEach(function (k) {
      var re = new RegExp('(^|\\s)' + k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?=\\s|$)', 'g');
      q = q.replace(re, function (_, lead) { return lead + ALIASES[k]; });
    });
    var text = number ? (q + ' ' + number).trim() : q;
    var full = year ? text + ' ' + year : text;
    return { series: q, number: number, year: year, grade: grade, text: text, full: grade ? full + ' ' + grade : full, hadThe: hadThe };
  }

  // Half the catalogue says "The Amazing Spider-Man", half "Amazing Spider-Man", and shoppers rarely
  // type "the". Searching both ways and mixing the results keeps either kind from crowding out the other.
  // Single words only get the second search when the shopper typed "the" ("the flash").
  function withAndWithoutThe(text, hadThe) {
    text = String(text || '').trim();
    return /^[a-z0-9]/i.test(text) && (hadThe || text.indexOf(' ') > -1) ? [text, 'the ' + text] : [text];
  }
  // Alternates between result lists (best of each first), dropping repeats.
  function interleave(lists, key) {
    var out = [], seen = {}, max = 0;
    lists.forEach(function (l) { max = Math.max(max, l.length); });
    for (var i = 0; i < max; i++) {
      lists.forEach(function (l) {
        var it = l[i];
        if (!it || seen[key(it)]) return;
        seen[key(it)] = 1;
        out.push(it);
      });
    }
    return out;
  }
  // Catalogue titles that are the search (ignoring "the") come first, then ones that start with it,
  // so "amazing spider man" leads with Amazing Spider-Man, not "Adventures in Reading Starring...".
  function rankSeries(rows, text) {
    var want = norm(text).replace(/^ the /, ' ');
    function score(r) {
      var name = norm(r.seriesName).replace(/^ the /, ' ');
      if (name === want) return 0;
      if (name.indexOf(want) === 0) return 1;
      if (name.indexOf(want) > -1) return 2;
      return 3;
    }
    return (rows || []).map(function (r, i) { return { r: r, s: score(r), i: i }; })
      .sort(function (a, b) { return a.s - b.s || a.i - b.i; })
      .map(function (x) { return x.r; });
  }

  // With a year: titles running that year first, the rest after in the same order.
  function byYear(rows, year) {
    if (!year) return rows || [];
    var y = Number(year);
    function hit(r) { return r.yearBegan && Number(r.yearBegan) <= y && (!r.yearEnded || Number(r.yearEnded) >= y); }
    return (rows || []).filter(hit).concat((rows || []).filter(function (r) { return !hit(r); }));
  }

  // Words for matching: lower case, punctuation and hyphens become spaces ("Spider-Man" = "spider man").
  function norm(s) { return ' ' + String(s || '').toLowerCase().replace(/[^a-z0-9.]+/g, ' ').replace(/\s+/g, ' ').trim() + ' '; }
  function tokens(s) { return norm(s).trim().split(' ').filter(Boolean); }
  function quoteTerm(t) { return /^[a-z0-9]+$/.test(t) ? t : '"' + t.replace(/"/g, '') + '"'; }

  // Storefront search query for the shopper's options.
  // opts: { kind, titleOnly, exact }
  function buildQuery(text, opts) {
    opts = opts || {};
    var q;
    var words = tokens(text);
    if (opts.titleOnly) {
      q = opts.exact
        ? 'title:"' + words.join(' ') + '"'
        : words.map(function (w, i) { return 'title:' + quoteTerm(w) + (i === words.length - 1 && /^[a-z0-9]+$/.test(w) ? '*' : ''); }).join(' AND ');
    } else {
      q = opts.exact ? '"' + String(text).replace(/"/g, '') + '"' : String(text);
    }
    var k = kindById(opts.kind);
    if (k.query) q = '(' + q + ') AND ' + k.query;
    return q;
  }

  // Double-checks results in the browser, so the options hold even where Shopify's search is looser.
  // item: { name|title, description? }
  function matches(item, text, opts) {
    opts = opts || {};
    if (!opts.titleOnly && !opts.exact) return true;
    var title = norm(item.title || item.name);
    var hay = opts.titleOnly ? title : title + norm(item.description || '');
    var words = tokens(text);
    if (!words.length) return true;
    if (opts.exact) {
      // Descriptions aren't always loaded; when missing, only the title can be checked.
      if (!opts.titleOnly && item.description == null && title.indexOf(' ' + words.join(' ') + ' ') < 0) return true;
      return hay.indexOf(' ' + words.join(' ') + ' ') > -1;
    }
    return words.every(function (w, i) {
      return i === words.length - 1 ? hay.indexOf(' ' + w) > -1 : hay.indexOf(' ' + w + ' ') > -1;
    });
  }

  // ---------- FOC countdown ----------

  var MONTHS = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };
  // Pre-sales carry a foc-YYYY-MM-DD tag, and a product type like "Oct 26 2026 FOC".
  function focDate(tags, type) {
    var d = null;
    (tags || []).some(function (t) {
      var m = String(t).match(/^foc-(\d{4})-(\d{2})-(\d{2})$/i);
      if (m) d = new Date(+m[1], +m[2] - 1, +m[3]);
      return !!d;
    });
    if (!d) {
      var m = String(type || '').match(/^([a-z]{3})[a-z]*\.? (\d{1,2}),? (\d{4}) foc$/i);
      if (m && MONTHS[m[1].toLowerCase()] != null) d = new Date(+m[3], MONTHS[m[1].toLowerCase()], +m[2]);
    }
    return d;
  }
  // { text, cls } for a pre-sale's final order cutoff, or null.
  function focBadge(tags, type, now) {
    var d = focDate(tags, type);
    if (!d) return null;
    var today = now ? new Date(now) : new Date();
    today.setHours(0, 0, 0, 0);
    var days = Math.round((d - today) / 864e5);
    if (days < 0) return { text: 'FOC passed', cls: 'is-past', days: days };
    if (days === 0) return { text: 'FOC today', cls: 'is-urgent', days: days };
    if (days === 1) return { text: 'FOC tomorrow', cls: 'is-urgent', days: days };
    if (days <= 14) return { text: 'FOC in ' + days + ' days', cls: days <= 3 ? 'is-urgent' : 'is-soon', days: days };
    return { text: 'FOC ' + d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }), cls: 'is-later', days: days };
  }

  // ---------- helpers ----------

  function esc(v) { var d = document.createElement('div'); d.textContent = v == null ? '' : String(v); return d.innerHTML; }
  function clean(u) { return String(u || '').split('?')[0]; }
  function sized(src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 300) : ''; }
  function money(p) {
    var n = Number(p);
    if (isNaN(n)) return '';
    return (CFG.moneyPrefix || '$') + n.toFixed(2);
  }
  function kindById(id) { for (var i = 0; i < KINDS.length; i++) if (KINDS[i].id === (id || '')) return KINDS[i]; return KINDS[0]; }
  function resultsUrl(q, prefs) {
    var u = new URL(CFG.searchUrl || (ROOT + 'search'), location.href);
    u.searchParams.set('q', q);
    if (prefs && prefs.kind) u.searchParams.set('kind', prefs.kind);
    if (prefs && prefs.titleOnly) u.searchParams.set('in', 'title');
    if (prefs && prefs.exact) u.searchParams.set('exact', '1');
    return u.pathname + u.search;
  }
  function advancedUrl(q, base) {
    base = base || CFG.advancedUrl || (ROOT + 'pages/advanced-search');
    return base + (base.indexOf('?') > -1 ? '&' : '?') + 'q=' + encodeURIComponent(q);
  }
  function skipImage(src) {
    var low = String(src || '').toLowerCase();
    return skipImages.some(function (v) { return low.indexOf(v) > -1; });
  }

  function classify(c) {
    var t = String(c.title || '');
    var m = t.match(/^(Writer|Cover Artist|Artist|Penciller|Inker|Colorist|Letterer|Editor):\s*(.+)$/i);
    if (m) return { g: 'creator', name: m[2], meta: m[1] };
    m = t.match(/^Character:\s*(.+)$/i);
    if (m) return { g: 'character', name: m[1] };
    m = t.match(/^Publisher:\s*(.+)$/i);
    if (m) return { g: 'publisher', name: m[1] };
    m = t.match(/^(.*?)\s*\(([^()]*\d{4}[^()]*)\)\s*$/);
    if (m) return { g: 'series', name: m[1], sub: m[2] };
    return null;
  }

  // Answers are remembered for a few minutes, so backspacing and retyping, or reopening the
  // box, doesn't fetch the same thing again. Only finished answers are kept, never failures.
  var answers = new Map();
  var ANSWER_MS = 5 * 60 * 1000, ANSWERS_MAX = 120;
  function getJson(url, opts, timeoutMs) {
    var timer = null;
    var key = url + '\n' + ((opts && opts.body) || '');
    var hit = answers.get(key);
    if (hit && Date.now() - hit.at < ANSWER_MS) return Promise.resolve(JSON.parse(hit.text));
    var req = fetch(url, opts)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (text) {
        if (text == null) return null;
        var data = JSON.parse(text);
        if (data && !data.errors) {
          answers.delete(key);
          answers.set(key, { at: Date.now(), text: text });
          if (answers.size > ANSWERS_MAX) answers.delete(answers.keys().next().value);
        }
        return data;
      })
      .catch(function (e) { if (e && e.name === 'AbortError') throw e; return null; });
    if (!timeoutMs) return req;
    var timeout = new Promise(function (resolve) { timer = setTimeout(function () { resolve(null); }, timeoutMs); });
    return Promise.race([req, timeout]).then(function (v) { clearTimeout(timer); return v; });
  }

  // ---------- remembered choices (this browser only) ----------

  function recentList() {
    try { var v = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); return Array.isArray(v) ? v.slice(0, RECENT_MAX) : []; }
    catch (e) { return []; }
  }
  function remember(q) {
    q = String(q || '').trim();
    if (q.length < MIN_CHARS) return;
    var list = recentList().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX))); } catch (e) { /* private mode */ }
  }
  function forgetAll() { try { localStorage.removeItem(RECENT_KEY); } catch (e) { /* ignore */ } }

  // kind, titleOnly and exact are shared by every search box for this visit.
  function loadPrefs() {
    var p = { kind: '', titleOnly: false, exact: false };
    try { var s = JSON.parse(sessionStorage.getItem(PREFS_KEY) || 'null'); if (s) { p.kind = s.kind || ''; p.titleOnly = !!s.titleOnly; p.exact = !!s.exact; } }
    catch (e) { /* ignore */ }
    // On the results page the URL is the truth.
    if (/\/search$/.test(location.pathname)) {
      var u = new URLSearchParams(location.search);
      if (u.has('q')) { p.kind = u.get('kind') || ''; p.titleOnly = u.get('in') === 'title'; p.exact = u.get('exact') === '1'; }
    }
    if (!kindById(p.kind).id) p.kind = '';
    return p;
  }
  var prefs = loadPrefs();
  var instances = [];
  function savePrefs() {
    try { sessionStorage.setItem(PREFS_KEY, JSON.stringify(prefs)); } catch (e) { /* ignore */ }
    instances.forEach(function (inst) { inst.syncPrefs(); });
  }

  // ---------- data ----------

  function suggestCollections(pq, scope, signal) {
    var prefixes = COLLECTION_QUERIES[scope] || [''];
    return Promise.all(prefixes.map(function (prefix) {
      var types = scope === 'all' || scope === 'title' ? 'product,collection,query' : 'collection';
      var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(prefix + pq.text) +
        '&resources[type]=' + types +
        '&resources[limit]=10&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=hide' +
        (prefs.titleOnly ? '&resources[options][fields]=title' : '');
      return getJson(url, { signal: signal });
    }));
  }

  function appSeries(text, number, size, signal) {
    var url = ROOT + 'apps/captcan/search?q=' + encodeURIComponent(text) + '&pageSize=' + (size || 6);
    if (number) url += '&number=' + encodeURIComponent(number);
    return getJson(url, { signal: signal, credentials: 'same-origin', headers: { Accept: 'application/json' } }, APP_TIMEOUT_MS)
      .then(function (app) { if (app && app.rows) app.rows = rankSeries(app.rows, text); return app; });
  }

  function fetchSeries(pq, scope, signal) {
    if (CFG.seriesSearch === false || (scope !== 'all' && scope !== 'title')) return Promise.resolve(null);
    if (pq.series.replace(/[^a-z0-9]/g, '').length < 3) return Promise.resolve(null);
    return appSeries(pq.series, pq.number, scope === 'title' ? 10 : 6, signal)
      .then(function (app) { if (app && app.rows) app.rows = byYear(app.rows, pq.year); return app; });
  }

  // A likely correction for a title the catalogue didn't find, from Shopify's typo-tolerant
  // suggestions: a matching series collection first, else a suggested search.
  function correctionFrom(suggestResults, original) {
    var orig = norm(original).trim();
    var pick = null;
    (suggestResults || []).some(function (data) {
      var res = (data && data.resources && data.resources.results) || {};
      (res.collections || []).some(function (c) {
        var k = classify(c);
        if (k && k.g === 'series' && norm(k.name).trim() !== orig) { pick = k.name; return true; }
        return false;
      });
      if (!pick) {
        (res.queries || []).some(function (x) {
          var t = String(x.text || '').trim();
          if (t && norm(t).trim() !== orig) { pick = t; return true; }
          return false;
        });
      }
      return !!pick;
    });
    return pick;
  }

  // "Did you mean" for any box: resolves to a corrected phrase or null.
  function didYouMean(text) {
    var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(text) +
      '&resources[type]=collection,query&resources[limit]=6&resources[limit_scope]=each';
    return getJson(url, {}).then(function (data) { return correctionFrom([data], text); }).catch(function () { return null; });
  }

  var PRODUCT_FIELDS = 'id handle title vendor productType tags availableForSale ' +
    'priceRange { minVariantPrice { amount } } featuredImage { url }';

  function storefront(query, variables, signal) {
    if (!CFG.storefrontToken || !CFG.shopDomain) return Promise.resolve(null);
    return getJson('https://' + CFG.shopDomain + '/api/' + (CFG.apiVersion || '2025-10') + '/graphql.json', {
      method: 'POST',
      signal: signal,
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': CFG.storefrontToken },
      body: JSON.stringify({ query: query, variables: variables })
    });
  }

  function productItem(n) {
    return {
      name: n.title,
      url: ROOT + 'products/' + n.handle,
      image: n.featuredImage && !skipImage(n.featuredImage.url) ? n.featuredImage.url : '',
      price: n.priceRange && n.priceRange.minVariantPrice ? n.priceRange.minVariantPrice.amount : null,
      available: n.availableForSale,
      vendor: n.vendor,
      tags: n.tags || [],
      type: n.productType,
      description: n.description
    };
  }

  // Product covers plus the total match count, narrowed by the shopper's options.
  function searchProducts(pq, limit, signal) {
    var opts = { kind: prefs.kind, titleOnly: prefs.titleOnly, exact: prefs.exact };
    var strict = opts.titleOnly || opts.exact;
    var fields = PRODUCT_FIELDS + (opts.exact && !opts.titleOnly ? ' description(truncateAt: 1500)' : '');
    return Promise.all(withAndWithoutThe(pq.text, pq.hadThe).map(function (text) {
      return storefront(
        'query($q: String!, $n: Int!, $p: SearchPrefixQueryType) { search(query: $q, first: $n, types: PRODUCT, prefix: $p, unavailableProducts: HIDE) { totalCount nodes { ... on Product { ' + fields + ' } } } }',
        { q: buildQuery(text, opts), n: strict ? Math.max(limit * 3, 30) : limit, p: opts.exact ? 'NONE' : 'LAST' }, signal
      );
    })).then(function (all) {
      var found = all.map(function (json) { return json && json.data && json.data.search; }).filter(Boolean);
      if (!found.length) return null;
      var items = interleave(found.map(function (s) {
        // Sold-out books stay out of the popup, as on the results page (Jay, 2026-10-18).
        return (s.nodes || []).filter(function (n) { return n && n.handle && n.availableForSale !== false; }).map(productItem)
          .filter(function (it) { return matches(it, pq.text, opts); });
      }), function (it) { return it.url; });
      if (pq.year) {
        var yr = new RegExp('\\b' + pq.year + '\\b');
        items = items.filter(function (it) { return yr.test(it.name); }).concat(items.filter(function (it) { return !yr.test(it.name); }));
      }
      // Copies in the asked-for grade first ("9.8", "nm"); the rest still show.
      if (pq.grade) {
        var gWant = norm(pq.grade).replace(/\b(cgc|cbcs|pgx)\b/g, '').trim();
        var hasGrade = function (it) { return gWant && norm(it.name).indexOf(' ' + gWant + ' ') > -1; };
        items = items.filter(hasGrade).concat(items.filter(function (it) { return !hasGrade(it); }));
      }
      var total = Math.max.apply(null, found.map(function (s) { return s.totalCount || 0; }));
      return { total: strict ? null : total, items: items.slice(0, limit) };
    });
  }

  // "amazing spider-man 300": the exact issue in each matching series, in stock or not, so a
  // shopper can open it or ask to be notified. Series come from the catalogue filtered to ones
  // that have that number; each series' issue list gives the issue id and our listed covers,
  // and the Storefront API says which listings are in stock.
  // Resolves to [{ name, sub, url, number, issueId, gid, inStock, productUrl }].
  function findIssues(pq, limit, signal) {
    if (!pq.number || CFG.seriesSearch === false || pq.series.replace(/[^a-z0-9]/g, '').length < 3) return Promise.resolve([]);
    limit = limit || 3;
    var want = pq.year ? limit + 4 : limit;
    return appSeries(pq.series, pq.number, want, signal).then(function (app) {
      var rows = byYear(((app && app.rows) || []).filter(function (r) { return r && r.seriesId != null; }), pq.year).slice(0, want);
      return Promise.all(rows.map(function (r) {
        return getJson(ROOT + 'apps/captcan/search/issues?seriesId=' + encodeURIComponent(r.seriesId),
          { signal: signal, credentials: 'same-origin', headers: { Accept: 'application/json' } }, APP_TIMEOUT_MS)
          .then(function (data) {
            var want = String(pq.number).toLowerCase();
            var book = ((data && data.books) || []).filter(function (b) { return String(b.number || '').trim().toLowerCase() === want; })[0];
            if (!book) return null;
            var covers = book.covers || [];
            var base = covers.filter(function (c) { return Number(c.issueId) === Number(book.baseIssueId); })[0] || covers[0] || {};
            var year = String(book.keyDate || '').slice(0, 4) || (r.yearBegan ? String(r.yearBegan) : '');
            return {
              name: r.seriesName + ' #' + book.number,
              sub: [r.publisherName, year].filter(Boolean).join(', ') + (covers.length > 1 ? ' \u00b7 ' + covers.length + ' covers' : ''),
              url: ROOT + 'pages/series?series_id=' + encodeURIComponent(r.seriesId) + '&issue=' + encodeURIComponent(book.number),
              number: book.number,
              year: year,
              issueId: book.baseIssueId,
              // the wishlist keys an unlisted issue by this sentinel, as the series page does
              gid: base.productGid || ('gid://captcan/Issue/' + book.baseIssueId),
              listed: covers.filter(function (c) { return c.productGid; }).map(function (c) { return c.productGid; }),
              coverIds: covers.map(function (c) { return String(c.issueId); }),
              // every copy we list for the series: graded copies are separate products, so the
              // issue's own product link can be a sold copy while another copy is in stock
              seriesGids: (r.productGids || []).slice(0, 300),
              // big series list more copies than that, so the issue is also searched by title
              lookup: r.seriesName.replace(/^the\s+/i, '') + ' ' + book.number,
              inStock: false,
              image: ''
            };
          });
      })).then(function (list) {
        list = list.filter(Boolean);
        // A year keeps the issues from that year when there are any; otherwise everything found stays.
        if (pq.year) {
          var sameYear = list.filter(function (it) { return it.year === pq.year; });
          if (sameYear.length) list = sameYear;
        }
        list = list.slice(0, limit);
        var seen = {}, gids = [];
        list.forEach(function (it) {
          it.listed.concat(it.seriesGids).forEach(function (g) { if (g && !seen[g]) { seen[g] = 1; gids.push(g); } });
        });
        if (!list.length) return list;
        var FIELDS = 'id handle availableForSale featuredImage { url } issueId: metafield(namespace: "custom", key: "issue_id") { value }';
        var chunks = [];
        for (var i = 0; i < gids.length; i += 100) chunks.push(gids.slice(i, i + 100));
        var byId = chunks.map(function (ids) {
          return storefront('query($ids: [ID!]!) { nodes(ids: $ids) { ... on Product { ' + FIELDS + ' } } }', { ids: ids }, signal)
            .then(function (json) { return (json && json.data && json.data.nodes) || []; });
        });
        var byTitle = list.map(function (it) {
          return storefront('query($q: String!) { search(query: $q, first: 100, types: PRODUCT, unavailableProducts: LAST) { nodes { ... on Product { ' + FIELDS + ' } } } }',
            { q: it.lookup }, signal)
            .then(function (json) { return (json && json.data && json.data.search && json.data.search.nodes) || []; }, function () { return []; });
        });
        return Promise.all(byId.concat(byTitle)).then(function (all) {
          var nodes = [], had = {};
          all.forEach(function (part) {
            part.forEach(function (n) { if (n && n.id && !had[n.id]) { had[n.id] = 1; nodes.push(n); } });
          });
          list.forEach(function (it) {
            var mine = nodes.filter(function (n) {
              return it.listed.indexOf(n.id) > -1 || (n.issueId && it.coverIds.indexOf(String(n.issueId.value).trim()) > -1);
            });
            var inStock = mine.filter(function (n) { return n.availableForSale; });
            it.inStock = inStock.length > 0;
            it.copies = inStock.length;
            // a cover photo: an in-stock copy, else one we've sold before
            var pic = inStock.concat(mine).filter(function (n) { return n.featuredImage && n.featuredImage.url && !skipImage(n.featuredImage.url); })[0];
            it.image = pic ? pic.featuredImage.url : '';
            if (inStock.length === 1) it.productUrl = ROOT + 'products/' + inStock[0].handle;
          });
          return list;
        });
      });
    }).catch(function (e) { if (e && e.name === 'AbortError') throw e; return []; });
  }

  // Row for a found issue: opens the issue on the series page; "Notify me" opens the wishlist.
  function issueRowHTML(it, id) {
    return '<div class="cc-hs__issue">' +
      '<a class="cc-hs__item" role="option" id="' + id + '" href="' + esc(it.url) + '" data-cc-remember>' +
      '<span class="cc-hs__thumb' + (it.inStock ? '' : ' is-past') + '">' + (it.image ? '<img src="' + esc(sized(it.image, 80)) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="cc-hs__text"><span class="cc-hs__name">' + esc(it.name) + '</span>' +
      '<span class="cc-hs__sub">' + esc(it.sub) + '</span></span>' +
      (it.inStock ? '<span class="cc-hs__meta is-stock">In stock</span>' : '') +
      '</a>' +
      (it.inStock ? '' : '<button type="button" class="cc-hs__notify" data-wishlist-trigger data-product-gid="' + esc(it.gid) +
        '" data-issue-id="' + esc(it.issueId) + '"><span class="cc-hs__n-add">Notify me</span><span class="cc-hs__n-on">On wishlist</span></button>') +
      '</div>';
  }

  var featuredCache = null;
  function featuredProducts() {
    if (!CFG.featuredCollection) return Promise.resolve([]);
    if (featuredCache) return featuredCache;
    featuredCache = getJson(ROOT + 'collections/' + encodeURIComponent(CFG.featuredCollection) + '/products.json?limit=' + (CFG.featuredCount || 10))
      .then(function (data) {
        return ((data && data.products) || []).filter(function (p) {
          return p.variants && p.variants.some(function (v) { return v.available; });
        }).map(function (p) {
          var img = p.images && p.images[0] ? p.images[0].src : '';
          return {
            name: p.title,
            url: ROOT + 'products/' + p.handle,
            image: skipImage(img) ? '' : img,
            price: p.variants[0] ? p.variants[0].price : null,
            available: true,
            vendor: p.vendor,
            tags: Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map(function (t) { return t.trim(); }),
            type: p.product_type
          };
        });
      });
    return featuredCache;
  }

  // ---------- grouping ----------

  function seriesRows(app) {
    return ((app && app.rows) || []).filter(function (r) { return r && r.seriesId != null; }).map(function (r) {
      var years = r.yearBegan ? r.yearBegan + (r.yearEnded ? '–' + r.yearEnded : '–present') : '';
      var inStock = (r.productGids || []).length;
      return {
        name: r.seriesName,
        sub: [r.publisherName, years].filter(Boolean).join(', '),
        meta: inStock ? (inStock >= 1000 ? '1,000+ books' : inStock + (inStock === 1 ? ' book' : ' books')) + ' in stock' : 'Get notified',
        metaClass: inStock ? 'is-stock' : 'is-muted',
        url: ROOT + 'pages/series?series_id=' + encodeURIComponent(r.seriesId)
      };
    });
  }

  function group(pq, collectionResults, app, products) {
    var g = { query: [], series: seriesRows(app), creator: [], character: [], publisher: [], product: [], issue: [] };
    var seen = {};
    var useCollectionSeries = !g.series.length;

    var suggestProducts = [];
    (collectionResults || []).forEach(function (data) {
      var res = (data && data.resources && data.resources.results) || {};
      (res.queries || []).forEach(function (x) {
        var text = String(x.text || '').trim();
        if (!text || seen['q:' + text.toLowerCase()] || text.toLowerCase() === pq.text) return;
        seen['q:' + text.toLowerCase()] = 1;
        g.query.push({ name: text, query: text });
      });
      (res.collections || []).forEach(function (c) {
        var k = classify(c);
        var url = clean(c.url);
        if (!k || seen[url]) return;
        if (k.g === 'series' && !useCollectionSeries) return;
        seen[url] = 1;
        k.url = url;
        g[k.g].push(k);
      });
      (res.products || []).forEach(function (p) {
        var url = clean(p.url);
        if (seen[url]) return;
        seen[url] = 1;
        var it = { name: p.title, url: url, image: skipImage(p.image) ? '' : p.image, price: p.price,
          available: p.available !== false, vendor: p.vendor, tags: p.tags || [], type: p.type };
        if (it.available && matches(it, pq.text, prefs) && kindMatches(it, prefs.kind)) suggestProducts.push(it);
      });
    });

    // Storefront search knows the kind and the total; predictive search catches typos.
    if (products && products.items.length) g.product = products.items;
    else g.product = suggestProducts;
    g.total = products ? products.total : null;
    return g;
  }

  function isPresale(it) {
    var tags = (it.tags || []).map(function (t) { return String(t).toLowerCase(); });
    return tags.indexOf('presale') > -1 || /\bfoc\b/i.test(it.type || '');
  }
  function kindMatches(it, kind) {
    if (kind === 'presales') return isPresale(it);
    if (kind === 'back-issues') return /^back issue/i.test(it.type || '');
    return true;
  }

  // ---------- markup ----------

  function cardHTML(p, id) {
    var badge = '';
    if (!p.available) badge = '<span class="cc-hs__badge is-out">Sold out</span>';
    else if (isPresale(p)) {
      var foc = focBadge(p.tags, p.type);
      badge = '<span class="cc-hs__badge is-pre">Pre-Sale</span>' +
        (foc ? '<span class="cc-hs__foc ' + foc.cls + '">' + esc(foc.text) + '</span>' : '');
    }
    return '<a class="cc-hs__card" role="option" id="' + id + '" href="' + esc(p.url) + '" data-cc-remember>' +
      '<span class="cc-hs__cover">' +
      (p.image ? '<img src="' + esc(sized(p.image, 300)) + '" alt="" loading="lazy">' : '') + badge + '</span>' +
      '<span class="cc-hs__card-title">' + esc(p.name) + '</span>' +
      (p.price != null ? '<span class="cc-hs__card-price">' + esc(money(p.price)) + '</span>' : '') +
      '</a>';
  }

  function rowHTML(it, id, cls) {
    return '<a class="cc-hs__item ' + (cls || '') + '" role="option" id="' + id + '" href="' + esc(it.url) + '"' +
      (it.query ? ' data-cc-query="' + esc(it.query) + '"' : '') + ' data-cc-remember>' +
      '<span class="cc-hs__text"><span class="cc-hs__name">' + esc(it.name) + '</span>' +
      (it.sub ? '<span class="cc-hs__sub">' + esc(it.sub) + '</span>' : '') + '</span>' +
      (it.meta ? '<span class="cc-hs__meta ' + (it.metaClass || '') + '">' + esc(it.meta) + '</span>' : '') +
      '</a>';
  }

  // ---------- one dropdown per search box ----------

  var uid = 0;

  // opts:
  //   scopeRow  show the "Search by" buttons inside the dropdown (default true)
  //   anchor    element the dropdown lines up under (default: the form)
  //   width     'wide' (centred, up to maxWidth) or 'anchor' (lined up with the anchor, at least 860px)
  //   onScope   called with the scope id when the scope changes
  //   browse    { character|creator|publisher: url } for Enter when nothing matches
  //   advancedUrl  where Titles searches go (default CFG.advancedUrl)
  function attach(form, input, opts) {
    opts = opts || {};
    if (!input || input.dataset.ccSearch) return null;
    input.dataset.ccSearch = '1';
    // Fast Simon's documented opt-out, in case its script is still loaded somewhere.
    input.classList.add('isp_ignore');

    var id = 'cc-hs-' + (++uid);
    var state = { scope: opts.scope || 'all', active: -1, lastKey: '' };
    var anchor = opts.anchor || form;
    var showScopes = opts.scopeRow !== false;

    // "What" picker in the box.
    // A small "Shop" label over the choice; the native select stays for keyboards and phones.
    // The header renders this picker in Liquid (live-search-form) so it is there on first paint;
    // other boxes get one built here.
    var kindWrap = input.parentNode.querySelector('.cc-hs-kindwrap');
    var kindSel = kindWrap && kindWrap.querySelector('select.cc-hs-kind');
    if (!kindSel) {
      kindSel = document.createElement('select');
      kindSel.className = 'cc-hs-kind';
      kindSel.setAttribute('aria-label', 'Search in');
      kindSel.innerHTML = KINDS.map(function (k) { return '<option value="' + k.id + '">' + k.label + '</option>'; }).join('');
      kindWrap = document.createElement('span');
      kindWrap.className = 'cc-hs-kindwrap';
      kindWrap.innerHTML = '<span class="cc-hs-kindlabel" aria-hidden="true">Shop</span>';
      kindWrap.appendChild(kindSel);
      input.parentNode.insertBefore(kindWrap, input);
    }
    kindSel.value = prefs.kind;
    function syncKindLook() { kindWrap.classList.toggle('is-narrowed', !!kindSel.value); }
    syncKindLook();
    kindSel.addEventListener('change', syncKindLook);
    form.classList.add('cc-hs-form');

    var panel = document.createElement('div');
    panel.className = 'cc-hs';
    panel.id = id;
    panel.hidden = true;
    panel.innerHTML =
      '<div class="cc-hs__bar">' +
      (showScopes
        ? '<div class="cc-hs__scopes" role="group" aria-label="Search by"><span class="cc-hs__bar-label">Search by</span>' +
          SCOPES.map(function (s) {
            return '<button type="button" class="cc-hs__scope" data-scope="' + s.id + '" aria-pressed="' + (s.id === state.scope) + '">' + s.label + '</button>';
          }).join('') + '</div>'
        : '') +
      '<div class="cc-hs__opts" role="group" aria-label="Match options"><span class="cc-hs__bar-label">Match in</span>' +
      '<button type="button" class="cc-hs__opt" data-opt="all">Titles &amp; descriptions</button>' +
      '<button type="button" class="cc-hs__opt" data-opt="title">Titles only</button>' +
      '<label class="cc-hs__exact"><input type="checkbox" data-opt-exact> Exact phrase</label></div>' +
      '</div>' +
      '<div class="cc-hs__body" role="listbox" aria-label="Search suggestions"></div>';
    document.body.appendChild(panel);
    var body = panel.querySelector('.cc-hs__body');
    var exactBox = panel.querySelector('[data-opt-exact]');

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', id);

    var timer = null;
    var ctrl = null;

    function syncPrefs() {
      kindSel.value = prefs.kind;
      syncKindLook();
      panel.querySelectorAll('.cc-hs__opt').forEach(function (b) {
        b.setAttribute('aria-pressed', String((b.dataset.opt === 'title') === prefs.titleOnly));
      });
      exactBox.checked = prefs.exact;
      state.lastKey = '';
    }
    syncPrefs();

    function setScope(scope) {
      if (!PLAN[scope]) scope = 'all';
      state.scope = scope;
      panel.querySelectorAll('.cc-hs__scope').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.scope === scope)); });
      state.lastKey = '';
      if (opts.onScope) opts.onScope(scope);
    }

    function items() { return [].slice.call(body.querySelectorAll('a[role="option"]')); }

    function place() {
      if (panel.hidden) return;
      var r = anchor.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight || r.width === 0) { close(); return; }
      var vw = document.documentElement.clientWidth;
      var width, left;
      if (opts.width === 'anchor') {
        // At least 860px wide on desktop so titles and covers sit side by side.
        width = Math.min(vw - 16, Math.max(r.width, 860));
        left = Math.max(8, Math.min(r.left, vw - width - 8));
      } else {
        width = Math.min(vw - 16, CFG.maxWidth || 1400);
        left = Math.round((vw - width) / 2);
      }
      if (isNarrow()) {
        // phones: a full-width sheet from under the search box to the bottom of the screen
        panel.style.left = '0px';
        panel.style.width = vw + 'px';
        panel.style.top = Math.round(r.bottom) + 'px';
        panel.style.maxHeight = panel.style.height = Math.max(240, window.innerHeight - r.bottom) + 'px';
      } else {
        panel.style.left = left + 'px';
        panel.style.width = width + 'px';
        panel.style.top = Math.round(r.bottom + 8) + 'px';
        panel.style.height = '';
        panel.style.maxHeight = Math.max(240, window.innerHeight - r.bottom - 20) + 'px';
      }
      panel.classList.toggle('is-narrow', isNarrow());
    }
    function isNarrow() { return document.documentElement.clientWidth < 760; }
    function open() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); state.active = -1; place(); }
    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      state.active = -1;
    }
    function setActive(i) {
      var list = items();
      list.forEach(function (el) { el.classList.remove('is-active'); el.setAttribute('aria-selected', 'false'); });
      if (!list.length) { state.active = -1; return; }
      state.active = (i + list.length) % list.length;
      var el = list[state.active];
      el.classList.add('is-active');
      el.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', el.id);
      el.scrollIntoView({ block: 'nearest' });
    }

    // Before typing: recent, popular, quick links and featured products.
    function chipHTML(it, cid, small) {
      return '<a class="cc-hs__chip" role="option" id="' + cid + '" href="' + esc(it.url) + '"' +
        (it.query ? ' data-cc-query="' + esc(it.query) + '"' : '') + ' data-cc-remember>' +
        (small ? '<small>' + esc(small) + '</small>' : '') + esc(it.name) + '</a>';
    }
    function railHTML(list, prefix) {
      return '<div class="cc-hs__rail">' + list.map(function (p, i) { return cardHTML(p, prefix + i); }).join('') + '</div>';
    }

    // Phones: chips instead of long lists, covers in a sideways row.
    function renderIdleNarrow() {
      var n = 0;
      var html = '';
      var recent = recentList();
      if (recent.length) {
        html += '<div class="cc-hs__sect"><div class="cc-hs__label">Recent<button type="button" class="cc-hs__clear" data-cc-clear>Clear</button></div><div class="cc-hs__chips">' +
          recent.map(function (q) { return chipHTML({ name: q, url: resultsUrl(q, prefs), query: q }, id + '-' + (n++)); }).join('') + '</div></div>';
      }
      var popular = CFG.popular || [];
      if (popular.length) {
        html += '<div class="cc-hs__sect"><div class="cc-hs__label">Popular</div><div class="cc-hs__chips">' +
          popular.map(function (q) { return chipHTML({ name: q, url: resultsUrl(q, prefs), query: q }, id + '-' + (n++)); }).join('') + '</div></div>';
      }
      var links = CFG.quickLinks || [];
      if (links.length) {
        html += '<div class="cc-hs__sect"><div class="cc-hs__label">' + esc(CFG.quickLinksTitle || 'Shop') + '</div><div class="cc-hs__chips">' +
          links.map(function (l) { return chipHTML({ name: l.title, url: l.url }, id + '-' + (n++)); }).join('') + '</div></div>';
      }
      body.innerHTML = '<div class="cc-hs__stack">' + html + '<div class="cc-hs__sect" data-cc-main></div></div>';
      open();
      featuredProducts().then(function (list) {
        var main = body.querySelector('[data-cc-main]');
        if (!main || !list.length || input.value.trim()) return;
        main.innerHTML = '<div class="cc-hs__label">' + esc(CFG.featuredTitle || 'Featured') + '</div>' + railHTML(list.slice(0, CFG.featuredCount || 10), id + '-f');
      });
    }

    function renderNarrow(q, g) {
      var n = 0;
      var html = '';
      var kind = kindById(prefs.kind);
      var parsed = parseQuery(q).full || q;
      var total = g.total;
      function sect(label, inner) { html += '<div class="cc-hs__sect"><div class="cc-hs__label">' + label + '</div>' + inner + '</div>'; }
      var scoped = state.scope === 'character' || state.scope === 'creator' || state.scope === 'publisher';
      if (scoped) {
        var key = state.scope;
        var list = g[key].slice(0, 12);
        if (list.length) sect(esc(SCOPES.filter(function (s) { return s.id === key; })[0].label), list.map(function (it) { return rowHTML(it, id + '-' + (n++)); }).join(''));
        else html += '<div class="cc-hs__empty">No ' + esc(key) + 's match \u201c' + esc(q) + '\u201d.</div>';
      } else {
        if (g.issue.length) sect('Issues', g.issue.slice(0, 3).map(function (it) { return issueRowHTML(it, id + '-' + (n++)); }).join(''));
        var label = (kind.id ? kind.label : 'Products') + (prefs.titleOnly ? ' \u00b7 titles only' : '') + (prefs.exact ? ' \u00b7 exact' : '') +
          (total ? '<span class="cc-hs__total">' + total.toLocaleString() + (total === 1 ? ' result' : ' results') + '</span>' : '');
        sect(label, g.product.length
          ? railHTML(g.product.slice(0, 10), id + '-p')
          : '<div class="cc-hs__empty">No ' + (kind.id ? esc(kind.label.toLowerCase()) : 'products') + ' match \u201c' + esc(q) + '\u201d' +
            (prefs.exact || prefs.titleOnly ? ' with these match options' : ' yet') + '.</div>');
        if (g.series.length) {
          sect('Titles' + (g.corrected ? '<span class="cc-hs__dym">for \u201c' + esc(g.corrected) + '\u201d</span>' : ''),
            g.series.slice(0, state.scope === 'title' ? 6 : 3).map(function (it) { return rowHTML(it, id + '-' + (n++)); }).join('') +
            '<a class="cc-hs__more" role="option" id="' + id + '-series" href="' + esc(advancedUrl(q, opts.advancedUrl)) + '" data-cc-remember>All titles matching \u201c' + esc(q) + '\u201d</a>');
        }
        var people = [];
        g.character.slice(0, 3).forEach(function (it) { people.push([it, 'Character']); });
        g.creator.slice(0, 3).forEach(function (it) { people.push([it, it.meta || 'Creator']); });
        g.publisher.slice(0, 2).forEach(function (it) { people.push([it, 'Publisher']); });
        var sugg = g.query.slice(0, 4);
        if (people.length || sugg.length) {
          sect('Related', '<div class="cc-hs__chips">' +
            people.map(function (x) { return chipHTML(x[0], id + '-' + (n++), x[1]); }).join('') +
            sugg.map(function (it) { return chipHTML({ name: it.name, url: resultsUrl(it.query, prefs), query: it.query }, id + '-' + (n++)); }).join('') +
            '</div>');
        }
      }
      var foot = scoped ? '' : '<div class="cc-hs__foot"><a class="cc-hs__all" role="option" id="' + id + '-all" href="' + esc(resultsUrl(parsed, prefs)) + '" data-cc-remember>' +
        'See all ' + (total ? total.toLocaleString() + ' ' : '') + 'results' + (kind.id ? ' in ' + esc(kind.label) : '') + '</a></div>';
      body.innerHTML = '<div class="cc-hs__stack">' + html + '</div>' + foot;
      open();
      if (g.issue.length && window.WISHLIST && window.WISHLIST.refresh) window.WISHLIST.refresh(body);
    }

    function renderIdle() {
      if (isNarrow()) return renderIdleNarrow();
      var n = 0;
      var side = '';
      var recent = recentList();
      if (recent.length) {
        side += '<div class="cc-hs__group"><div class="cc-hs__label">Recent searches<button type="button" class="cc-hs__clear" data-cc-clear>Clear</button></div>' +
          recent.map(function (q) { return rowHTML({ name: q, url: resultsUrl(q, prefs), query: q }, id + '-' + (n++), 'is-plain'); }).join('') + '</div>';
      }
      var popular = CFG.popular || [];
      if (popular.length) {
        side += '<div class="cc-hs__group"><div class="cc-hs__label">Popular searches</div>' +
          popular.map(function (q) { return rowHTML({ name: q, url: resultsUrl(q, prefs), query: q }, id + '-' + (n++), 'is-plain'); }).join('') + '</div>';
      }
      var links = CFG.quickLinks || [];
      if (links.length) {
        side += '<div class="cc-hs__group"><div class="cc-hs__label">' + esc(CFG.quickLinksTitle || 'Shop') + '</div>' +
          links.map(function (l) { return rowHTML({ name: l.title, url: l.url }, id + '-' + (n++), 'is-plain'); }).join('') + '</div>';
      }
      body.innerHTML = '<div class="cc-hs__side">' + side + '</div><div class="cc-hs__main" data-cc-main></div>';
      open();
      featuredProducts().then(function (list) {
        var main = body.querySelector('[data-cc-main]');
        if (!main || !list.length || input.value.trim()) return;
        var max = panel.classList.contains('is-narrow') ? 4 : (CFG.featuredCount || 10);
        main.innerHTML = '<div class="cc-hs__label">' + esc(CFG.featuredTitle || 'Featured') + '</div>' +
          '<div class="cc-hs__cards">' + list.slice(0, max).map(function (p) { return cardHTML(p, id + '-f' + (n++)); }).join('') + '</div>';
      });
    }

    function render(q, g) {
      if (isNarrow()) return renderNarrow(q, g);
      var n = 0;
      var side = '';
      (PLAN[state.scope] || PLAN.all).forEach(function (row) {
        var list = g[row[0]].slice(0, row[2]);
        if (!list.length) return;
        var heading = row[1];
        if (row[0] === 'series' && g.corrected) {
          heading += '<span class="cc-hs__dym">for “' + esc(g.corrected) + '”</span>';
        }
        side += '<div class="cc-hs__group" role="group" aria-label="' + row[1] + '"><div class="cc-hs__label">' + heading + '</div>' +
          list.map(function (it) {
            if (row[0] === 'query') it = { name: it.name, url: resultsUrl(it.query, prefs), query: it.query };
            if (row[0] === 'issue') return issueRowHTML(it, id + '-' + (n++));
            return rowHTML(it, id + '-' + (n++));
          }).join('') + '</div>';
      });
      if (!side && state.scope !== 'all' && state.scope !== 'title') {
        side = '<div class="cc-hs__empty">No ' + esc(SCOPES.filter(function (s) { return s.id === state.scope; })[0].label.toLowerCase()) + ' match “' + esc(q) + '”.</div>';
      }
      if (state.scope === 'title') {
        side += '<a class="cc-hs__more" role="option" id="' + id + '-series" href="' + esc(advancedUrl(q, opts.advancedUrl)) + '" data-cc-remember>All titles matching “' + esc(q) + '”</a>';
      }

      var max = panel.classList.contains('is-narrow') ? 4 : 10;
      var cards = g.product.slice(0, max);
      var kind = kindById(prefs.kind);
      var parsed = parseQuery(q).full || q;
      var total = g.total;
      var label = (kind.id ? kind.label : 'Products') + (prefs.titleOnly ? ' · titles only' : '') + (prefs.exact ? ' · exact' : '');
      var main = '<div class="cc-hs__label">' + esc(label) +
        (total ? '<span class="cc-hs__total">' + total.toLocaleString() + (total === 1 ? ' result' : ' results') + '</span>' : '') + '</div>';
      main += cards.length
        ? '<div class="cc-hs__cards">' + cards.map(function (p) { return cardHTML(p, id + '-p' + (n++)); }).join('') + '</div>'
        : '<div class="cc-hs__empty">No ' + (kind.id ? esc(kind.label.toLowerCase()) : 'products') + ' match “' + esc(q) + '”' +
          (prefs.exact || prefs.titleOnly ? ' with these match options' : ' yet') + '.</div>';
      main += '<a class="cc-hs__all" role="option" id="' + id + '-all" href="' + esc(resultsUrl(parsed, prefs)) + '" data-cc-remember>' +
        'See all ' + (total ? total.toLocaleString() + ' ' : '') + 'results for “' + esc(q) + '”' + (kind.id ? ' in ' + esc(kind.label) : '') + '</a>';
      if (CFG.advancedUrl && state.scope !== 'title') {
        main += '<a class="cc-hs__adv" role="option" id="' + id + '-adv" href="' + esc(advancedUrl(q, opts.advancedUrl)) + '">Search titles in the advanced search</a>';
      }

      body.innerHTML = (side ? '<div class="cc-hs__side">' + side + '</div>' : '') + '<div class="cc-hs__main">' + main + '</div>';
      open();
      if (g.issue.length && window.WISHLIST && window.WISHLIST.refresh) window.WISHLIST.refresh(body);
    }

    function keyNow(q) { return [q, prefs.kind, prefs.titleOnly, prefs.exact, state.scope].join('|'); }

    function run() {
      var q = input.value.trim();
      if (q.length < MIN_CHARS) {
        if (ctrl) ctrl.abort();
        renderIdle();
        return;
      }
      var key = keyNow(q);
      if (key === state.lastKey && body.innerHTML && !panel.hidden) return;
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var signal = ctrl ? ctrl.signal : undefined;
      var pq = parseQuery(q);
      form.classList.add('cc-hs-loading');
      Promise.all([
        suggestCollections(pq, state.scope, signal),
        fetchSeries(pq, state.scope, signal),
        searchProducts(pq, 10, signal),
        state.scope === 'all' || state.scope === 'title' ? findIssues(pq, 3, signal) : Promise.resolve([])
      ])
        .then(function (r) {
          // Titles not found as typed: retry with Shopify's typo-tolerant guess.
          var wantsSeries = CFG.seriesSearch !== false && (state.scope === 'all' || state.scope === 'title') && pq.series.length >= 3;
          if (wantsSeries && !seriesRows(r[1]).length) {
            var fix = correctionFrom(r[0], pq.series);
            if (fix) {
              return appSeries(parseQuery(fix).series, null, state.scope === 'title' ? 10 : 6, signal).then(function (app) {
                if (seriesRows(app).length) { r[1] = app; r.corrected = fix; }
                return r;
              });
            }
          }
          return r;
        })
        .then(function (r) {
          if (input.value.trim() !== q || key !== keyNow(q)) return;
          state.lastKey = key;
          var g = group(pq, r[0], r[1], r[2]);
          g.issue = r[3] || [];
          g.corrected = r.corrected || null;
          render(q, g);
          track('header_search_suggest', { q: q, kind: prefs.kind, scope: state.scope, titleOnly: prefs.titleOnly, exact: prefs.exact });
        })
        .catch(function () {})
        .then(function () { form.classList.remove('cc-hs-loading'); });
    }

    function schedule() { clearTimeout(timer); timer = setTimeout(run, DEBOUNCE_MS); }

    kindSel.addEventListener('change', function () {
      prefs.kind = kindSel.value;
      savePrefs();
      input.focus();
      run();
    });
    panel.addEventListener('mousedown', function (e) {
      // Keep focus in the box while using the panel's controls.
      if (e.target.closest('button')) e.preventDefault();
    });
    panel.addEventListener('change', function (e) {
      if (e.target === exactBox) { prefs.exact = exactBox.checked; savePrefs(); input.focus(); run(); }
    });
    panel.addEventListener('click', function (e) {
      var scopeBtn = e.target.closest('.cc-hs__scope');
      if (scopeBtn) { setScope(scopeBtn.dataset.scope); input.focus(); run(); return; }
      var optBtn = e.target.closest('.cc-hs__opt');
      if (optBtn) { prefs.titleOnly = optBtn.dataset.opt === 'title'; savePrefs(); input.focus(); run(); return; }
      if (e.target.closest('[data-cc-clear]')) { forgetAll(); renderIdle(); input.focus(); return; }
      // wishlist.js opens its modal from the same click; get out of its way.
      if (e.target.closest('[data-wishlist-trigger]')) { remember(input.value); close(); return; }
      var link = e.target.closest('a[data-cc-remember]');
      if (link) remember(link.dataset.ccQuery || input.value);
    });

    input.addEventListener('input', schedule);
    input.addEventListener('focus', function () { run(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (panel.hidden) run(); else setActive(state.active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (!panel.hidden) setActive(state.active - 1); }
      else if (e.key === 'Escape') { close(); }
    });

    function go(url) { window.location.href = url; }

    // Capture phase so our routing wins over the theme's own submit handling.
    form.addEventListener('submit', function (e) {
      var list = items();
      var q = input.value.trim();
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!panel.hidden && state.active > -1 && list[state.active]) {
        remember(list[state.active].dataset.ccQuery || q);
        go(list[state.active].href);
        return;
      }
      if (!q) { input.focus(); return; }
      remember(q);
      track('header_search_submit', { q: q, kind: prefs.kind, scope: state.scope, titleOnly: prefs.titleOnly, exact: prefs.exact });
      if (state.scope === 'title') { go(advancedUrl(q, opts.advancedUrl)); return; }
      if (state.scope === 'character' || state.scope === 'creator' || state.scope === 'publisher') {
        var first = body.querySelector('.cc-hs__side a[role="option"]');
        if (first && !panel.hidden) { go(first.href); return; }
        if (opts.browse && opts.browse[state.scope]) { go(opts.browse[state.scope]); return; }
      }
      go(resultsUrl(parseQuery(q).full || q, prefs));
    }, true);

    document.addEventListener('click', function (e) {
      var path = e.composedPath ? e.composedPath() : [e.target];
      if (path.indexOf(form) < 0 && path.indexOf(panel) < 0 && !form.contains(e.target) && !panel.contains(e.target)) close();
    });
    window.addEventListener('scroll', place, { passive: true });
    window.addEventListener('resize', place);

    var api = { setScope: function (s) { setScope(s); if (input.value.trim().length >= MIN_CHARS) run(); }, syncPrefs: syncPrefs, run: run, close: close, panel: panel };
    instances.push(api);
    return api;
  }

  // Report searches to PostHog (already loaded by the theme) so no-result searches can be reviewed.
  function track(name, props) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, props);
    } catch (e) { /* analytics must never break search */ }
  }

  function init() {
    // On the results page the header box shows the current search (the page hides its own box
    // on phones), selected on first tap so typing replaces it.
    var current = /\/search$/.test(location.pathname) ? (new URLSearchParams(location.search).get('q') || '') : '';
    [].slice.call(document.querySelectorAll('form[data-live-search-form]')).forEach(function (form) {
      var input = form.querySelector('input[name="q"]');
      var fresh = input && !input.dataset.ccSearch;
      attach(form, input, {});
      if (fresh && current && !input.value) {
        input.value = current;
        input.addEventListener('focus', function once() { input.removeEventListener('focus', once); setTimeout(function () { input.select(); }, 0); });
      }
    });
  }

  window.ccSearch = {
    attach: attach,
    parseQuery: parseQuery,
    buildQuery: buildQuery,
    matches: matches,
    didYouMean: didYouMean,
    focBadge: focBadge,
    findIssues: findIssues,
    byYear: byYear,
    rankSeries: rankSeries,
    prefs: function () { return { kind: prefs.kind, titleOnly: prefs.titleOnly, exact: prefs.exact }; }
  };
  window.ccHeaderSearch = CFG;
  CFG.parseQuery = parseQuery;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.dispatchEvent(new CustomEvent('cc:search-ready'));
})();
